import React, { useEffect } from 'react';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { SectionHeader, BfiCustomStore, Accordion } from '../common/SharedComponents';
import PrincipalsTable from './tables/PrincipalsTable';
import CompaniesTable from './tables/CompaniesTable';
import EntitiesTable from './tables/EntitiesTable';
import debounce from 'lodash.debounce';
import { BorrowerModals } from './common/BorrowerComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function DeletedBorrowersLanding() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const gridStore1 = new BfiCustomStore();
    const gridStore2 = new BfiCustomStore();
    const gridStore3 = new BfiCustomStore();
    const debouncedSearch = debounce(dispatch, 500);

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    borrowerPerson: event.target.value,
                },
            })
        );
    };

    useEffect(() => {
        return () => {
            //Cancel any further searches if component is unloaded
            debouncedSearch.cancel();
        };
    }, []);

    return (
        <>
            <SectionHeader title='Clients - Recycle Bin' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search on Name, City or State...'
                        defaultValue={searchState?.searchText?.borrowerPerson}
                        onChange={(event) => _onSearchChange(event)}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div
                    className='scrollable-content'
                    style={{ paddingTop: '5px' }}
                >
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <Accordion
                            title='Businesses'
                            isExpanded={true}
                            id={`borrower_company_deleted`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <CompaniesTable
                                        gridStore={gridStore1}
                                        isDeleted={true}
                                    />
                                </div>
                            </div>
                        </Accordion>
                        <Accordion
                            title='Entities'
                            isExpanded={true}
                            id={`borrower_entity_deleted`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <EntitiesTable
                                        gridStore={gridStore2}
                                        isDeleted={true}
                                    />
                                </div>
                            </div>
                        </Accordion>
                        <Accordion
                            title='Principals'
                            isExpanded={true}
                            id={`borrower_principal_deleted`}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <PrincipalsTable
                                        gridStore={gridStore3}
                                        isDeleted={true}
                                    />
                                </div>
                            </div>
                        </Accordion>
                    </div>
                </div>
            </div>
            <BorrowerModals />
        </>
    );
}

export default DeletedBorrowersLanding;
